<template>
  <div class="products-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <el-row>
          <h1 style="width: 100%">行业案例</h1>
        </el-row>
        <el-row>
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>行业案例</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-row>
      </div>
    </div>
    <div class="container container2">
      <!-- 产品分类菜单 -->
      <div class="product-category">
        <el-menu
            :default-active="activeCategory"
            class="category-menu"
            @select="toggleDataSource">
          <el-menu-item index="xxhxmzjzx">信息化项目造价咨询</el-menu-item>
          <el-menu-item index="gzxmzjzx">工程项目造价咨询</el-menu-item>
          <el-menu-item index="kxxyjbg">可行性研究报告</el-menu-item>
        </el-menu>
      </div>
      <!-- 产品列表 -->
      <div class="product-list">
        <el-row :gutter="20" v-for="(product, index) in filteredProducts" :key="index" class="product-item">
          <el-col :xs="24" :md="4" class="product-img-col">
            <div @click="showProductDetail(product)"  class="product-img">
              <img :src="product.image" :alt="product.name" class="img-fluid">
            </div>
          </el-col>
          <el-col :xs="24" :md="20" class="product-content-col">
              <div class="product-content" @click="showProductDetail(product)" style="cursor: pointer;">
                <div class="product-header">
                  <h3 class="product-title">{{ product.name }}</h3>
                  <div class="product-date"></div>
                </div>
                <p class="product-description">{{ product.shortDescription }}</p>    
              </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
              background
              layout="prev, pager, next"
               :background-color='"#fff"'
              :total="totalProducts"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              style="background-color: #fff;"
              @current-change="handlePageChange"
              >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {productKx} from '@/views/industData/IndustryKx.js';
import {productZj} from '@/views/industData/IndustryZj.js';
import {productXx} from '@/views/industData/IndustryXx.js';
export default {
  name: 'Industry',
  data() {
    return {
      activeCategory: 'xxhxmzjzx',
      currentPage: 1,
      pageSize: 5,
      dialogVisible: false,
      selectedProduct: {},
      currentDataSource: 'zj', 
      productKx,
      productZj,
      productXx
    }
  },
  watch: {
    // 监听路由变化，处理标签切换
    '$route.query.tab': {
      handler() {
        this.handleRouteChange()
      },
      immediate: true
    }
  }, 
  mounted() {
    // 获取当前路由参数，设置默认分类
    const currentTab = new URL(location).searchParams.get('tab');
    if (currentTab) {
      this.toggleDataSource(currentTab);
    }
    // 检查是否有保存的页面状态，如果有则恢复
    this.$nextTick(() => {
      const savedState = sessionStorage.getItem('industryPageState')
      if (savedState) {
        const pageState = JSON.parse(savedState)
        // 恢复页面状态
        this.currentPage = pageState.currentPage
        this.currentDataSource = pageState.currentDataSource
        this.activeCategory = pageState.activeCategory
        // 延迟执行滚动，确保DOM已渲染完成
        setTimeout(() => {
          window.scrollTo({ top: pageState.scrollPosition, behavior: 'smooth' })
        }, 10)
        // 清除已使用的状态数据
        sessionStorage.removeItem('industryPageState')
      }
    }); 
  },  
  computed: {
    totalProducts() {
      let sourceData;
      if (this.currentDataSource === 'kx') {
        sourceData = this.productKx;
      } else if (this.currentDataSource === 'zj') {
        sourceData = this.productZj;
      } else {
        sourceData = this.productXx;
      }
      return sourceData.length;
    },
    filteredProducts() {
      // 选择数据源
      let sourceData;
      if (this.currentDataSource === 'kx') {
        sourceData = this.productKx;
      } else if (this.currentDataSource === 'zj') {
        sourceData = this.productZj;
      } else {
        sourceData = this.productXx;
      }
      // 应用分页
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      
      return sourceData.slice(startIndex, endIndex);
    },
  },
  methods: {
     // 处理路由变化
    handleRouteChange() {
      const tab = this.$route.query.tab
      if (tab) {
        this.toggleDataSource(tab)
        // 使用 nextTick 确保 DOM 已更新
        this.$nextTick(() => {
          this.scrollToSection(tab, false)
        })
      }
    },
     // 滚动到指定部分
    scrollToSection(sectionId, updateTab = true) {
      if (updateTab) {
        this.activeTab = sectionId
      }
      
      this.$nextTick(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          // 使用平滑滚动效果
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      })
    },
    // 切换数据源方法
    toggleDataSource(key) {
      // 根据选中的菜单索引设置对应的数据源
      this.activeCategory = key; // 设置当前激活的分类
      if (key === 'xxhxmzjzx') {
        this.currentDataSource = 'zj'; // 信息化项目造价咨询
      } else if (key === 'gzxmzjzx') {
        this.currentDataSource = 'xx'; // 工程项目造价咨询
      } else if (key === 'kxxyjbg') {
        this.currentDataSource = 'kx'; // 可行性研究报告
      }
      this.currentPage = 1; // 切换数据源后重置到第一页
    },
    // handleCategorySelect方法已合并到toggleDataSource中，此处移除
    handlePageChange(page) {
      this.currentPage = page
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
    showProductDetail(product) {
      // 检测是否为移动设备
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        // 移动端：保存当前滚动位置和页面状态到sessionStorage，使用Vue路由导航
        const scrollPosition = window.scrollY
        const pageState = {
          scrollPosition: scrollPosition,
          currentPage: this.currentPage,
          currentDataSource: this.currentDataSource,
          activeCategory: this.activeCategory
        }
        sessionStorage.setItem('industryPageState', JSON.stringify(pageState))
        // 使用Vue路由导航到详情页
        this.$router.push({ path: '/IndustryDetail', query: { id: product.id } })
      } else{
        const baseUrl = window.location.origin
        const url = `${baseUrl}/IndustryDetail?id=${product.id}`
        window.open(url, '_blank');
      }
    
    },
    shareNews() {
      this.$message({
        message: '新闻分享功能已触发',
        type: 'success'
      })
    },
    downloadProductDoc() {
      this.$message({
        message: '产品资料下载中，请稍候...',
        type: 'success'
      })
    },
    goToContact() {
      this.$router.push('/contact')
    }
  }, 
  created() {
    // 获取当前路由参数，设置默认分类
    const category = this.$route.query.category
    if (category) {
      this.activeCategory = category
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col-lg-6 {
  width: 100%;
}

.products-page {
  padding-bottom: 60px;

  .container2 {
    display: flex;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .product-category {
    width: 200px;
    margin-right: 30px;

    @media (max-width: 768px) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
    }

    .category-menu {
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .el-menu-item {
        &.is-active {
          background-color: #e8f4fd;
        }
      }

    }
  }

  .product-list {
    flex: 1;

    .product-item {
      margin-bottom: 10px;
      padding-bottom: 20px;
      padding-top: 10px;
      border-bottom: 1px solid #eee;
    }

    .product-img-col {
      padding-right: 5px;
    }

    .product-img {
      width: 160px;
      height: 100px;
      overflow: hidden;
      border-radius: 4px;
      object-fit: cover;
      
      @media (max-width: 768px) {
        width: 100%;
        height: 200px;
        margin-bottom: 10px;
      }
    }

    .product-img img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s;
    }

    .product-img:hover img {
      transform: scale(1.05);
    }

    .product-content {
      padding-top: 0;
      margin-left: 15px;
    }

    .product-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .product-title {
      font-size: 19px;
      color: #333;
      font-weight: bold;
      margin-right: 20px;
      margin-bottom: 0;
       @media (max-width: 868px) {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
    }
    
    .product-date {
      font-size: 14px;
      color: #999;
      margin-bottom: 0;
    }

    .product-description {
      color: #666;
      font-size: 14px;
      line-height: 1.6;
      margin-bottom: 15px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .pagination-container {
      text-align: center;
      margin-top: 30px;
    }
  }
}

// 新闻详情样式
.news-detail {
  padding: 0px 0;

  .news-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;

    h2 {
      font-size: 24px;
      color: #333;
      letter-spacing:2px;
      margin-bottom: 15px;
      font-weight: bold;
    }

    .news-meta {
      display: flex;
      color: #999;
      font-size: 14px;

      .news-date {
        margin-right: 20px;
      }
    }
  }

  .news-content {
    margin-bottom: 30px;

    .news-image {
      margin-bottom: 20px;
      text-align: center;

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
      }
    }

    .news-text {
      color: #666;
      line-height: 1.8;
      font-size: 16px;

      p {
        margin-bottom: 15px;
      }
    }
  }

  .news-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

}

.page-header {
  background-image: url('/img/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    color: #fff;
  }

  .breadcrumb {
    margin-top: 10px;
    
    .el-breadcrumb {
      font-size: 14px;
      
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
            color: rgba(255, 255, 255, 0.8);
            
            &:hover {
              color: #1ebec8 !important;
            }
          }
        
        &:first-child {
          .el-breadcrumb__inner {
            color: #1ebec8 !important;
             
          }
        }
        
        &:last-child {
          .el-breadcrumb__inner {
            color: #1ebec8 !important;
          }
        }
      }
    }
  }
}

:deep( .el-pagination.is-background .btn-prev)
{
  background-color: #ffffff !important;
}
:deep(.el-pagination.is-background .btn-next)
{
  background-color: #ffffff !important;
}

:deep(.el-pagination.is-background .el-pager li) {
  background-color: #ffffff !important;
}

:deep(.el-dialog__header){
  padding: 0 !important;
}

</style>
